const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

/**
 * Prefixes a root-relative `public/` path with Vite's base.
 *
 * Vite rewrites the asset URLs it can see — HTML references, CSS `url()`, real
 * imports — but not string literals handed to three.js loaders or `<img src>`.
 * The catalogs in `src/data` keep their paths base-free on purpose: those same
 * strings are persisted into saved `.json` projects, so they must stay portable
 * across mount points. The base is applied here, at load time, instead.
 *
 * `data:` and `blob:` URLs (custom textures, uploaded GLBs) pass through.
 */
export function assetUrl(path: string): string {
  return path.startsWith("/") ? `${BASE}${path}` : path;
}
